var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappySadFacesStreamlineFlex1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2281 6.44769V7.17676",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9204 6.44769V7.17676",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.574 15.1959C11.2412 15.1959 8.80408 12.7587 8.80408 8.42597C8.80408 4.09322 11.2412 1.65607 15.574 1.65607C19.9067 1.65607 22.3439 4.09322 22.3439 8.42597C22.3439 12.7587 19.9067 15.1959 15.574 15.1959Z",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8297 9.9295C18.3454 11.1755 17.2236 11.8535 15.5745 11.8535C13.9254 11.8535 12.8036 11.1755 12.3193 9.9295",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6813 19.0339C11.1971 17.788 10.0753 17.1099 8.42619 17.1099C6.77706 17.1099 5.65529 17.788 5.17102 19.0339",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77234 14.0903V14.8194",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7015 18.5856C13.7852 21.0189 11.621 22.3441 8.42601 22.3441C4.09329 22.3441 1.65613 19.9068 1.65613 15.5741C1.65613 12.3792 2.98134 10.215 5.4146 9.29865",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappySadFacesStreamlineFlex1);
export default __webpack_public_path__ + "static/media/Happy-Sad-Faces--Streamline-Flex 1.a2709efe6a32c2e7a874fe7ade7dfe1c.svg";
export { ForwardRef as ReactComponent };